import { Component, Input } from '@angular/core';
import { Store, createSelector } from '@ngrx/store';
import { QuillEditorComponent, QuillModules } from 'ngx-quill';
import { BehaviorSubject, combineLatest, map } from 'rxjs';


import { QuillTemplateLocation } from '../../../../generated/graphql.generated';
import { FreyaCommonModule } from '../../../freya-common/freya-common.module';
import { JOB_SUMMARIES, jobSummaryDefaultToolbar } from '../../../global.constants';
import { QuillTemplateVariableToolbarDirective } from '../../../shared/quill-template-variable.directive';
import { SharedModule } from '../../../shared/shared.module';
import { JobSummaryActions } from '../../job-create/job-create-summary/job-create-summary.actions';
import { JobCreateSummaryComponent } from "../../job-create/job-create-summary/job-create-summary.component";
import { jobCreateSummaryFeature } from '../../job-create/job-create-summary/job-create-summary.feature';
import {
  
  selectJobInCurrentZone,
  selectJobLoaded,
} from '../../job-tool.reducer';

@Component({
  selector: 'app-overview-summary',
  standalone: true,
  imports: [
    FreyaCommonModule,
    SharedModule,
    QuillEditorComponent,
    JobCreateSummaryComponent,
    QuillTemplateVariableToolbarDirective
  ],
  templateUrl: './overview-summary.component.html',
  styleUrls: [
    './overview-summary.component.scss',
    '../overview-header/overview-chip/shared.overview-chip.component.scss',
  ]
})
export class OverviewSummaryComponent {

  @Input() header = 'Summary';

  private _summaryKey$ = new BehaviorSubject<typeof JOB_SUMMARIES[number]['key']>(null);

  @Input({ required: true }) set summaryKey(value: typeof JOB_SUMMARIES[number]['key']) {
    this._summaryKey$.next(value);
  }

  public viewModel$ = combineLatest([
    this._summaryKey$,
    this.store.select(createSelector({
      jobLoaded: selectJobLoaded,
      jobNotInZone: createSelector(selectJobInCurrentZone, (inZone) => !inZone),
      summaryEditors: jobCreateSummaryFeature.selectSummaryEditors,
    })),
  ]).pipe(
    map(([summaryKey, { jobLoaded, jobNotInZone, summaryEditors }]) => ({
      jobLoaded,
      jobNotInZone,
      summaryKey,
      content: summaryEditors[summaryKey],
      summaryDescription: JOB_SUMMARIES.find(s => s.key === summaryKey)?.description ?? '',
      editorId: JOB_SUMMARIES.find(s => s.key === summaryKey)?.editorId ?? 'unknownEditor',
      templatesLocations: this.getTemplatesLocations(summaryKey),
    })),
  );

  public editModules: QuillModules = {
    toolbar: jobSummaryDefaultToolbar,
    variableToolbar: true,
    templateToolbar: true,
  };

  public actions = JobSummaryActions;

  public variablesLocation = QuillTemplateLocation.JobSummary;

  getTemplatesLocations(summaryKey: typeof JOB_SUMMARIES[number]['key']) {
    const locations = [QuillTemplateLocation.JobSummary];
    switch (summaryKey) {
      case 'crewSummary':
        locations.push(QuillTemplateLocation.JobCrewSummary);
        break;
      case 'adminSummary':
        locations.push(QuillTemplateLocation.JobAdminSummary);
        break;
      case 'customerSummary':
        locations.push(QuillTemplateLocation.JobCustomerSummary);
        break;
    }
    return locations;
  }

  constructor(
    public store: Store,
  ) { }
}
